import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/features/auth/hooks/useAuth";

export const GLOBAL_TENANT_OPTION_ID = "__global__";

export interface PromptTenantOption {
  id: string;
  name: string;
}

/** Tenants the signed-in user may author prompts for, with Global first. */
export function usePromptTenantOptions(): PromptTenantOption[] {
  const { t } = useTranslation();
  const tenants = useAuth((s) => s.tenants);

  return useMemo(() => {
    const permitted = tenants
      .filter((tenant) =>
        tenant.permissions.some((p) => p.type === "PAGE" && p.route === "prompts"),
      )
      .map((tenant) => ({ id: tenant.id, name: tenant.name }))
      .sort((a, b) => a.name.localeCompare(b.name));

    return [
      {
        id: GLOBAL_TENANT_OPTION_ID,
        name: t("prompts.editor.tenantGlobal", "Global (no tenant)"),
      },
      ...permitted,
    ];
  }, [tenants, t]);
}
